var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar-brand',[_c('strong',{staticClass:"logo-icon"},[_c('img',{staticClass:"logo logo-navbar",attrs:{"src":_vm.aciquiLogo,"alt":"homepage"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }